const webRoot = process.env.WEB_ROOT
const apiProtocol = process.env.API_PROTOCOL
const apiPort = process.env.API_PORT
const apiVersion = process.env.API_VERSION

let apiServer
if (process.env.NODE_ENV === 'development') apiServer = process.env.API_SERVER
else apiServer = location.hostname.replace(/^www/, 'api')

let port = (apiPort === 80) ? '' : ':' + apiPort
let head = apiProtocol + '://' + apiServer + port + '/' + apiVersion

export default {
  WEB_ROOT: webRoot,
  URL_HEAD: head,
  API_PROTOCOL: apiProtocol,
  API_SERVER: apiServer,
  API_VERSION: apiVersion,
  COOKIES_TTL: process.env.COOKIES_TTL
}



// WEBPACK FOOTER //
// ./src/scripts/consts/Env.js